export const defaultCurrencies = [
  {
    label: "POL - Polygon (Polygon)",
    value: "POL",
    icon: "https://media.bananacrystal.com/wp-content/uploads/2023/07/20151846/matic.png",
  },
  {
    label: "OPAIG - Opaig (Opaig)",
    value: "OPAIG",
    icon: "https://media.bananacrystal.com/wp-content/uploads/2023/06/12010252/logo512_480.png",
  },
];

export const allCurrencies = [
  {
    label: "POL - Polygon (Polygon)",
    value: "POL",
    icon: "https://media.bananacrystal.com/wp-content/uploads/2023/07/20151846/matic.png",
  },
  {
    label: "OPAIG - Opaig (Opaig)",
    value: "OPAIG",
    icon: "https://media.bananacrystal.com/wp-content/uploads/2023/06/12010252/logo512_480.png",
  },
  {
    label: "ETH - Ethereum (Ethereum)",
    value: "ETH-ETH",
    icon: "https://upload.wikimedia.org/wikipedia/commons/7/70/Ethereum_logo.svg",
  },
  {
    label: "USDT - USDT (Ethereum)",
    value: "USDT-ETH",
    icon: "https://etherscan.io/token/images/tether28_2.png",
  },
];
